/**
 * @desc 根据入参条件查询相关物料信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MaterialRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.MaterialDTO>>> {
  return defHttp.post({
    url: '/web/materialManage/queryMaterialInfo',
    data,
  });
}

export function mock(
  data: defs.MaterialRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.MaterialDTO>>> {
  return defHttp.post({
    url: '/mock/web/materialManage/queryMaterialInfo',
    data,
  });
}
